module.exports = __webpack_public_path__ + "static/media/image_72.a8697851.png";